import getTourFirstPaymentDefinitionService from '@/js/common/Domain/Service/getTourFirstPaymentDefinition';
import countryConditions from '@ve/components/countryConditions/common/store/countryConditions';
import OperatorsRepository from '@/js/common/Domain/Repository/Operators';
import apiRailwayToursToRailwayToursProducts from '@/js/common/components/railwayTours/Domain/service/apiRailwayToursToRailwayToursProducts';
import RailwayTourProduct from '@/js/common/components/railwayTours/Domain/factory/RailwayTourProductFactory';
import populateRoomDescriptions from '@/js/common/Domain/Service/hotelSearch/services/populateRoomDescriptions';
import {
    productCompareKey,
    rawProductCompareKey,
} from '@/js/common/Domain/Service/search/getCompareKeys';

export default function updateRailwayTours(data) {
    const operatorsRepository = OperatorsRepository.repository;

    const {
        searchData,
        tourProductsRepository,
        railwayToursRepository,
    } = data;

    const {
        countries,
        legs,
        operators = [],
        railwaysTours,
        rooms = [],
        routes = [],
        tariffs = [],
        firstPaymentDefinitions = [],
        stations = [],
    } = searchData;

    operatorsRepository.add(operators);

    if (typeof console !== 'undefined' && typeof console.log === 'function') {
        console.time('builRailwayTours');
    }

    if (countries) {
        countryConditions.update(countries);
    }

    const railwayToursWithRoomDescriptions = populateRoomDescriptions({
        tours: railwaysTours,
        rooms,
    });

    const populatedRailwayTourProducts = apiRailwayToursToRailwayToursProducts({
        railwayTours: railwayToursWithRoomDescriptions,
        firstPaymentDefinitions,
        routes,
        tariffs,
        legs,
        stations,
    });

    if (typeof console !== 'undefined' && typeof console.log === 'function') {
        console.log('RailwayTours from request:', populatedRailwayTourProducts?.length || 0);
    }

    const currentRailwayToursIndex = railwayToursRepository.map(productCompareKey);

    if (populatedRailwayTourProducts) {
        const railwayTourProducts = _.reduce(populatedRailwayTourProducts, (newRailwayTourProduct, rawRailwayTour) => {
            const rawRailwayTourKey = rawProductCompareKey(rawRailwayTour);
            if (!~_.indexOf(currentRailwayToursIndex, rawRailwayTourKey)) {
                const firstPaymentDefinition = getTourFirstPaymentDefinitionService(newRailwayTourProduct);
                const allFirstPaymentDefinitions = newRailwayTourProduct?.firstPaymentDefinitions || [];

                newRailwayTourProduct.push(new RailwayTourProduct({
                    ...rawRailwayTour,
                    firstPaymentDefinition,
                    allFirstPaymentDefinitions,
                }));
            }

            return newRailwayTourProduct;
        }, []);

        railwayToursRepository.add(railwayTourProducts, {
            merge: true,
        });
        tourProductsRepository.add(railwayTourProducts, {
            merge: true,
        });

        if (typeof console !== 'undefined' && typeof console.log === 'function') {
            console.timeEnd('builRailwayTours');
            console.log('Added new railwayTours:', railwayTourProducts.length);
        }

        return railwayTourProducts;
    }

    return [];
}
